module.exports = __webpack_public_path__ + "img/2.7a88e433.png";